import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

function Header() {
  return (
    <header className="header">
      <h1 className="header-title">Seattle Street Bulletin</h1>
      <nav className="header-nav">
        {/* <Link to="/" className="nav-link">Home</Link> */}
        <Link to="/about" className="nav-link">About</Link>
        {/* <Link to="/events" className="nav-link">Events</Link> */}
      </nav>
    </header>
  );
}

export default Header;